// removed by extract-text-webpack-plugin
module.exports = {"list":"_3_JlX","album":"_3wPN7","thumb":"_1b85g","name":"_3zv4i","info":"_3H8mD","button":"_2OfIj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/album/AddImagesToAlbum.css
// module id = 813
// module chunks = 0